import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight, CalendarDays, Check } from "lucide-react";
import { api, imgSrc } from "../../lib/api";
import { Sparkle } from "./Decor";

export const fmtDate = (d) => new Date(`${d}T12:00:00`).toLocaleDateString(undefined, { month: "short", day: "numeric" });

const PromoButton = ({ p }) => {
  const text = p.button_text || (p.link_url ? "Learn more" : "Start a Custom Order");
  const cls = "btn-pink mt-8 self-start";
  if (!p.link_url) return <Link to="/order" className={cls} data-testid={`promo-btn-${p.id}`}>{text} <ArrowRight className="h-4 w-4" /></Link>;
  if (p.link_url.startsWith("/")) return <Link to={p.link_url} className={cls} data-testid={`promo-btn-${p.id}`}>{text} <ArrowRight className="h-4 w-4" /></Link>;
  return <a href={p.link_url} target="_blank" rel="noreferrer" className={cls} data-testid={`promo-btn-${p.id}`}>{text} <ArrowUpRight className="h-4 w-4" /></a>;
};

const PromoCard = ({ p }) => {
  const img = imgSrc(p);
  return (
    <div className={`relative mx-auto grid max-w-7xl overflow-hidden rounded-[2rem] bg-[#0E0B0D] text-white ${img ? "lg:grid-cols-[1fr_1.1fr]" : ""}`} data-testid={`promo-${p.id}`}>
      <Sparkle className="absolute right-8 top-8 z-10" size={22} />
      {img && <img src={img} alt={p.title} className="h-72 w-full object-cover object-top lg:h-full lg:max-h-[620px]" />}
      <div className="flex flex-col justify-center p-8 sm:p-12">
        <p className="eyebrow flex items-center gap-2">
          {p.ends_on ? <><CalendarDays className="h-3.5 w-3.5" />Ends {fmtDate(p.ends_on)}</> : "Limited time"}
        </p>
        <h2 className="mt-3 font-display text-3xl font-bold leading-tight sm:text-4xl">{p.title}</h2>
        {p.description && <p className="mt-4 whitespace-pre-line text-white/75">{p.description}</p>}
        {p.deals.length > 0 && (
          <div className="mt-8 grid grid-cols-2 gap-3" data-testid={`promo-deals-${p.id}`}>
            {p.deals.map((d, i) => (
              <div key={i} className="gold-trim rounded-2xl p-4">
                <p className="font-display text-3xl font-black text-[#EBD08A]">{d.price}</p>
                <p className="mt-1 text-sm text-white/80">{d.label}</p>
              </div>
            ))}
          </div>
        )}
        {p.extras.length > 0 && (
          <ul className="mt-6 grid gap-2 text-sm text-white/80 sm:grid-cols-2">
            {p.extras.map((x, i) => <li key={i} className="flex items-start gap-2"><Check className="mt-0.5 h-4 w-4 shrink-0 text-[#FF1F8E]" />{x}</li>)}
          </ul>
        )}
        {p.note && <p className="mt-5 text-xs text-white/55">{p.note}</p>}
        <PromoButton p={p} />
      </div>
    </div>
  );
};

export const Promotions = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/promotions").then((r) => setItems(r.data)).catch(() => {}); }, []);
  if (!items.length) return null;
  return (
    <section className="space-y-8 px-4 py-16 sm:px-6" data-testid="promotions-section">
      {items.map((p) => <PromoCard key={p.id} p={p} />)}
    </section>
  );
};
